import type { AxiosPromise } from 'axios'
import request from '@core/request'

/**
 *{
  "companyName": "奥迪股份公司",
  "brandShortName": "奥迪",
  "ourProducts": ["奥迪A4", "奥迪A6", "奥迪Q5"],
  "competitorProducts": ["宝马3", "宝马5", "宝马x6"],
  "mode": "ai_search"
}
 */
export function insightGenerate(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/portrait/generate',
    // baseURL: '/brand-insight',
    data,
  })
}
export function insightQuery(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/portrait/query',
    // baseURL: '/brand-insight',
    data,
  })
}
export function insightUpdate(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/portrait/update',
    // baseURL: '/brand-insight',
    data,
  })
}
export function insightConfirm(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/portrait/confirm',
    // baseURL: '/brand-insight',
    data,
  })
}
export function questionPoolList(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/list',
    // baseURL: '/brand-insight',
    errorMessageShow: false,
    data,
  })
}
export function questionPoolGenerate(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/generate',
    // baseURL: '/brand-insight',
    data,
  })
}
export function questionPoolDelete(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/question/batch-delete',
    // baseURL: '/brand-insight',
    data,
  })
}
export function questionTemplate(data: any, config?: Record<string, any>): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/template',
    // baseURL: '/brand-insight',
    data,
    ...config,
  })
}
export function questionUpdate(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/question/update',
    // baseURL: '/brand-insight',
    data,
  })
}
export function questionPoolUpload(data: FormData): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/upload',
    // baseURL: '/brand-insight',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  })
}
export function questionAdd(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/question/add',
    // baseURL: '/brand-insight',
    data,
  })
}
export function questionPoolConfirm(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/question-pool/confirm',
    // baseURL: '/brand-insight',
    data,
  })
}
export function executionSteps(data: any): AxiosPromise {
  return request({
    method: 'get',
    url: '/brand-insight/execution/steps',
    // baseURL: '/brand-insight',
    data,
  })
}
export function executionDetail(data: any, config?: Record<string, any>): AxiosPromise {
  return request({
    method: 'get',
    url: '/brand-insight/execution/detail',
    // baseURL: '/brand-insight',
    data,
    ...config,
  })
}
// 生成报告分享临时密钥（expireHours 以小时为单位）
export function reportSharing(data: {
  executionId: string | number
  expireHours: number
}): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/execution/report/sharing',
    data,
  })
}
// 通过分享临时密钥免登查询执行详情（/firecrawl 路径不经网关登录校验，返回结构同 executionDetail）
export function reportSharedDetail(data: { key: string }): AxiosPromise {
  return request({
    method: 'get',
    url: '/firecrawl/brand-insight-report',
    data,
  })
}
// 重新生成报告（会扣除报告生成权益）
export function reportRegenerate(data: {
  executionId: string | number
  portraitId?: string | number
}): AxiosPromise {
  return request({
    method: 'post',
    url: '/brand-insight/report/regenerate',
    data,
  })
}
export function streamEvents(data: any): AxiosPromise {
  return request({
    method: 'get',
    url: '/brand-insight/stream/events',
    errorMessageShow: false,
    data,
  })
}
export function questionSteps(data: any): AxiosPromise {
  return request({
    method: 'get',
    url: '/brand-insight/execution/question/steps',
    // baseURL: '/brand-insight',
    data,
  })
}
export function stepQuestions(data: any, config?: Record<string, any>): AxiosPromise {
  return request({
    method: 'get',
    url: '/brand-insight/execution/step/questions',
    // baseURL: '/brand-insight',
    data,
    ...config,
  })
}
